// extracted by mini-css-extract-plugin
export default {"password_changed_success":"Auth_password_changed_success__cJ4wn","div_container":"Auth_div_container__SCm3I","password_changed":"Auth_password_changed__BR3nV"};